import styled from 'styled-components';
import { fontSmoothing } from '@finect/tabular-utils/fontSmoothing';

export const CurrentPageLink = styled.a`
  display: inline-block;
  width: 33px;
  border-radius: 33px;
  background-color: ${({ theme }) => theme.mainColor};
  ${fontSmoothing}
  line-height: 33px;
  color: #fff;
  text-align: center;
`;
